import { useSelector } from 'react-redux';
import SaveCaptionButton from './components/web/SaveCaptionButton';
import { getRoleParticipant } from '../base/participants';
import { ROLE_PARTICIPANT_ROOM } from '../base/constants/default';
const savecaption = {
    key: 'savecaption',
    Content: SaveCaptionButton,
    group: 2
};
/**
 * A hook that returns the CC button if it is enabled and undefined otherwise.
 *
 *  @returns {Object | undefined}
 */
export function useSaveCaptionButton() {
    const { local } = useSelector((state) => state['features/base/participants']);
    const isLocalModerator = useSelector((state) => getRoleParticipant(state, local?.id));
    if (isLocalModerator !== ROLE_PARTICIPANT_ROOM.PARTICIPANT)
        return savecaption;
    return;
}
